import { render, staticRenderFns } from "./VerArquivosRolagem.vue?vue&type=template&id=0a33f75c&scoped=true&"
import script from "./VerArquivosRolagem.vue?vue&type=script&lang=js&"
export * from "./VerArquivosRolagem.vue?vue&type=script&lang=js&"
import style0 from "./VerArquivosRolagem.vue?vue&type=style&index=0&id=0a33f75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33f75c",
  null
  
)

export default component.exports